import { Route } from 'react-router-dom';
import { lazyPage } from './lazyPage';

const QuickAdd = lazyPage(() => import('../pages/staff/casenotes/QuickAdd'), 'QuickAdd');
const Search = lazyPage(() => import('../pages/staff/casenotes/Search'), 'Search');
const StudentList = lazyPage(() => import('../pages/staff/casenotes/StudentList'), 'StudentList');
const StudentNotes = lazyPage(() => import('../pages/staff/casenotes/StudentNotes'), 'StudentNotes');
const Analytics = lazyPage(() => import('../pages/staff/casenotes/Analytics'), 'Analytics');
const DetailedAnalytics = lazyPage(() => import('../pages/staff/casenotes/DetailedAnalytics'), 'DetailedAnalytics');
const Admin = lazyPage(() => import('../pages/staff/casenotes/Admin'), 'Admin');
const FlaggedNotes = lazyPage(() => import('../pages/staff/casenotes/FlaggedNotes'), 'FlaggedNotes');

/** Case Notes pages open to every staff member. */
export const caseNotesStaffRoutes = (
  <>
    <Route path="/staff/case-notes" element={<QuickAdd />} />
    <Route path="/staff/case-notes/edit/:noteId" element={<QuickAdd />} />
    <Route path="/staff/case-notes/search" element={<Search />} />
    <Route path="/staff/case-notes/students" element={<StudentList />} />
    <Route path="/staff/case-notes/student/:studentId" element={<StudentNotes />} />
    <Route path="/staff/case-notes/flagged" element={<FlaggedNotes />} />
    <Route path="/staff/case-notes/admin" element={<Admin />} />
  </>
);

/** Case Notes analytics: fullAccess only (not LD Assistants). */
export const caseNotesFullAccessRoutes = (
  <>
    <Route path="/staff/case-notes/analytics" element={<Analytics />} />
    <Route path="/staff/case-notes/analytics/detailed" element={<DetailedAnalytics />} />
  </>
);
